import deVerb from './DeVerb';

type TTemplate = {
  DefinitionPane: React.ComponentType<{
    word: TWord;
    finished: boolean;
  }>;
  ValuePane: React.ComponentType<{
    word: TWord;
    disabled: boolean;
    finished: boolean;
  }>;
};

const templates: Record<
  Exclude<TDeckTemplate, TDeckTemplateEnum['default']>,
  TTemplate
> = { deVerb };

export default templates;
